const actions = {
    page_title: 'Actions',
    title: 'Actions',
    subtitle: 'Execute código personalizado em pontos específicos do fluxo de autenticação para estender o comportamento do Logto.',
    status: {
        not_configured: 'Não configurado',
        configured: 'Configurado',
        enabled: 'Ativado',
        disabled: 'Desativado',
    },
    types: {
        post_first_factor_verification: {
            name: 'Após a verificação do primeiro fator',
            description: 'Execute lógica personalizada após a falha na verificação da senha local durante o login.',
        },
        post_sign_in: {
            name: 'Após o login',
            description: 'Execute lógica personalizada após um usuário entrar com sucesso.',
        },
    },
    data_source_tab: 'Fonte de dados',
    test_tab: 'Contexto de teste',
    settings_tab: 'Configurações',
    event_data: {
        title: 'Payload do evento',
        subtitle: 'Use o parâmetro de entrada `event` para os dados do evento de autenticação.',
    },
    result_data: {
        title: 'Resultado da ação',
        subtitle: 'Retorne um objeto de resultado que o Logto entenda para este tipo de ação.',
    },
    environment_variables: {
        title: 'Definir variáveis de ambiente',
        subtitle: 'Use variáveis de ambiente para armazenar informações sensíveis.',
        input_field_title: 'Adicionar variáveis de ambiente',
        sample_code: 'Acessando variáveis de ambiente no manipulador da ação. Exemplo:',
    },
    fetch_external_data: {
        title: 'Buscar dados externos',
        subtitle: 'Chame APIs externas a partir do script da ação.',
        description: 'Use a função `fetch` para chamar suas APIs externas e incluir os dados no resultado da ação. Exemplo:',
    },
    settings: {
        title: 'Configurações',
        subtitle: 'Controle se a ação está ativa e como os erros de tempo de execução são tratados.',
        enabled: {
            title: 'Ativar ação',
            description: 'Execute este script quando o evento de autenticação for acionado.',
        },
        on_execution_error: {
            title: 'Em caso de erro no script',
            description: 'Escolha como o Logto deve se comportar quando o script falhar em tempo de execução.',
            block: 'Bloquear o fluxo de autenticação',
            allow: 'Permitir que o fluxo de autenticação continue',
            post_first_factor_description: 'Quando este script falha, o Logto sempre rejeita credenciais inválidas para que a verificação de senha não possa ser contornada.',
        },
    },
    test_context: {
        subtitle: 'Ajuste o payload de evento simulado usado ao executar testes.',
        input_field_title: 'JSON de exemplo do evento',
    },
    script: {
        title: 'Script',
        restore: 'Restaurar padrões',
        restored: 'Restaurado',
    },
    tester: {
        run_button: 'Executar teste',
        result_title: 'Resultado do teste',
    },
    form_error: {
        invalid_json: 'Formato JSON inválido',
    },
    sandbox_and_security_warning: {
        title: 'Os scripts são executados com privilégios do servidor',
        description: 'No Logto auto-hospedado, este script é executado no mesmo ambiente que o próprio Logto: ele pode ler variáveis de ambiente do servidor e acessar serviços na sua rede interna. Não está em sandbox. Conceda acesso a esta página apenas a pessoas em quem você confiaria o acesso ao servidor. Esta ação é executada somente após a falha na verificação da senha local — retorne `passwordVerified: true` somente depois de verificar de forma independente a senha enviada. Usuários provisionados por esta ação ignoram proteções exclusivas do registro, incluindo blocklist de e-mail, domínio apenas SSO, modo de cadastro desativado e verificações de perfil obrigatório no registro. Gravações de perfil e senha de usuários existentes também ocorrem antes da conclusão da MFA.',
    },
    sandbox_warning: {
        title: 'Os scripts são executados com privilégios do servidor',
        description: 'No Logto auto-hospedado, este script é executado no mesmo ambiente que o próprio Logto: ele pode ler variáveis de ambiente do servidor e acessar serviços na sua rede interna. Não está em sandbox. Conceda acesso a esta página apenas a pessoas em quem você confiaria o acesso ao servidor.',
    },
    security_warning: {
        title: 'Aviso de segurança',
        description: 'Esta ação é executada somente após a falha na verificação da senha local. Retorne `passwordVerified: true` somente depois de verificar de forma independente a senha enviada. Usuários provisionados por esta ação ignoram proteções exclusivas do registro, incluindo blocklist de e-mail, domínio apenas SSO, modo de cadastro desativado e verificações de perfil obrigatório no registro. Gravações de perfil e senha de usuários existentes também ocorrem antes da conclusão da MFA.',
    },
    delete_modal_title: 'Excluir ação',
    delete_modal_content: 'Tem certeza de que deseja excluir esta ação? O fluxo de autenticação não executará mais este script.',
    deleted: 'Ação excluída',
    created: 'Ação criada',
    saved: 'Ação salva',
};
export default Object.freeze(actions);
